import {
  OperatorProjectAppearance,
  OperatorProjectId,
  type OperatorSnapshot,
} from "@maito/contracts";
import * as Schema from "effect/Schema";

export const OperatorStartupSnapshot = Schema.Struct({
  version: Schema.Literal(2),
  appearance: Schema.optionalKey(OperatorProjectAppearance),
  projects: Schema.Array(
    Schema.Struct({
      id: OperatorProjectId,
      name: Schema.String,
      appearance: Schema.optionalKey(OperatorProjectAppearance),
      operatorName: Schema.optionalKey(Schema.String),
    }),
  ),
  selectedProjectId: Schema.String,
});
export type OperatorStartupSnapshot = typeof OperatorStartupSnapshot.Type;

/** A bounded first-view projection; unrelated histories never enter the startup cache. */
export function projectOperatorStartup(
  snapshot: OperatorSnapshot,
  selection: { readonly projectId: string },
): OperatorStartupSnapshot {
  const projects = snapshot.projects
    .filter((project) => project.archivedAt === undefined)
    .toSorted((a, b) => Number(b.id === selection.projectId) - Number(a.id === selection.projectId))
    .slice(0, 40)
    .map(({ id, name, appearance, operatorName }) => ({
      id,
      name: name.slice(0, 200),
      ...(appearance === undefined ? {} : { appearance }),
      ...(operatorName === undefined ? {} : { operatorName: operatorName.slice(0, 200) }),
    }));
  return {
    version: 2,
    ...(snapshot.appearance === undefined ? {} : { appearance: snapshot.appearance }),
    projects,
    selectedProjectId: selection.projectId,
  };
}
